module.exports = __webpack_public_path__ + "img/brandon-martinez.4bbf9923.png";